/*
 * @Author: chengyu
 * @Date: 2022-09-22 19:46:50
 * @Description: 地图服务各环境对应域名
 */
var _a;
import { EnvEnum } from '../enums';
import { getConfig } from './index';
var services = (_a = {},
    _a[EnvEnum.FAT] = {
        LBS: 'https://fat-hello-location-based-services.hellobike.com',
        GAO_DE: 'https://restapi.amap.com',
    },
    _a[EnvEnum.UAT] = {
        LBS: 'https://uat-hello-location-based-services.hellobike.cn',
        GAO_DE: 'https://restapi.amap.com',
    },
    _a[EnvEnum.PRE] = {
        LBS: 'https://pre-hello-location-based-services.hellobike.cn',
        GAO_DE: 'https://restapi.amap.com',
    },
    _a[EnvEnum.PRO] = {
        LBS: 'https://hello-location-based-services.hellobike.com',
        GAO_DE: 'https://restapi.amap.com',
    },
    _a);
export function getService() {
    var config = getConfig();
    return services[config.env] || services[EnvEnum.FAT];
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29yZS9jb25maWcvc2VydmljZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRzs7QUFFSCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBRW5DLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFcEMsSUFBTSxRQUFRO0lBT1osR0FBQyxPQUFPLENBQUMsR0FBRyxJQUFHO1FBQ2IsR0FBRyxFQUFFLHlEQUF5RDtRQUM5RCxNQUFNLEVBQUUsMEJBQTBCO0tBQ25DO0lBQ0QsR0FBQyxPQUFPLENBQUMsR0FBRyxJQUFHO1FBQ2IsR0FBRyxFQUFFLHdEQUF3RDtRQUM3RCxNQUFNLEVBQUUsMEJBQTBCO0tBQ25DO0lBQ0QsR0FBQyxPQUFPLENBQUMsR0FBRyxJQUFHO1FBQ2IsR0FBRyxFQUFFLHdEQUF3RDtRQUM3RCxNQUFNLEVBQUUsMEJBQTBCO0tBQ25DO0lBQ0QsR0FBQyxPQUFPLENBQUMsR0FBRyxJQUFHO1FBQ2IsR0FBRyxFQUFFLHFEQUFxRDtRQUMxRCxNQUFNLEVBQUUsMEJBQTBCO0tBQ25DO09BQ0YsQ0FBQztBQUVGLE1BQU0sVUFBVSxVQUFVO0lBQ3hCLElBQU0sTUFBTSxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBQzNCLE9BQU8sUUFBUSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsSUFBSSxRQUFRLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBQ3ZELENBQUMifQ==